import { initialize } from '@harnessio/ff-javascript-client-sdk'

export default ({
  identifier,
  attributes: { roles, linkedServiceIDs },
}: {
  identifier: string
  attributes: {
    roles: string[]
    linkedServiceIDs: string[]
  }
}) =>
  initialize(import.meta.env.VITE_FEATURE_FLAG_CLIENT_ID, {
    identifier,
    attributes: {
      roles,
      linkedServiceIDs,
    },
  })

export { Event } from '@harnessio/ff-javascript-client-sdk'
